export const DEFAULT_PLATFORM = "Likvi.com";